<template>
    <div class="page-subheader">
        <div v-if="!hideBackButton">
            <q-btn
                no-caps outline
                label="Back"
                size="md"
                icon="chevron_left"
                class="back-button"
                color="blue-grey"
                @click="goBack"/>
        </div>
        <div class="page-title-container">
            <slot name="page-title">
                <div class="page-title">
                    <h2>{{ pageTitle }}</h2>
                </div>
                <slot name="new-instance-link">
                    <router-link class="add-link" :to="newInstancePageLink" v-if="newInstancePageLink">
                        <q-btn color="blue" :label="newInstanceLabel" icon="add" tag="a" no-caps/>
                    </router-link>
                </slot>
            </slot>
        </div>
    </div>
</template>
<script>
export default {
    name: 'page-subheader',
    props: {
        pageTitle: {
            type: String,
            required: false,
        },
        newInstancePageLink: {
            type: Object,
            required: false,
        },
        entityName: {
            type: String,
            required: false,
        },
        hideBackButton: {
            type: Boolean,
            default: false,
        },
    },
    computed: {
        newInstanceLabel() {
            if (this.entityName) {
                return `New ${this.entityName}`;
            }
            return '';
        },
    },
    methods: {
        goBack() {
            return window.history.back();
        },
    },
};
</script>
<style lang="scss">
.page-subheader {
    .page-title-container {
        display: flex;
        flex-flow: row;
        justify-content: space-between;
        align-items: center;
        padding-top: 20px;
        padding-bottom: 10px;

        .page-title {
            display: flex;
            flex-flow: row;
            align-items: center;
            height: max-content;

            .header-icon {
                height: 45px;
                margin: 15px;

            }

            > h2 {
                text-transform: capitalize;
                color: #222;
                font-weight: 500;
                font-size: 35px;
                margin: 0;
            }
        }

        .add-link {
            text-decoration: none;
        }

        .q-btn {
            height: 36px;
        }
    }

    .back-button {
        padding: 2px 14px 2px 4px;

        .q-btn__content {
            .q-icon {
                margin-right: 0;
            }

            > span {
                line-height: 24px;
            }
        }
    }
}
</style>
